/**
 * Fully resolves all path translations.
 * If a path translation is a message-function, it will be evaluated for each language.
 *
 * Does NOT perform any validation.
 *
 * @param userTranslations The user-provided path translation configuration.
 * @param availableLanguageTags The available language tags.
 * @returns The resolved path translations.
 */
export function resolvePathTranslations(userTranslations, availableLanguageTags) {
    const translations = {};
    for (const path in userTranslations) {
        const translation = userTranslations[path];
        if (!translation)
            continue;
        if (typeof translation === "object") {
            translations[path] = userTranslations[path];
            continue;
        }
        translations[path] = fromMessage(translation, availableLanguageTags);
    }
    return translations;
}
function fromMessage(message, availableLanguageTags) {
    const entries = availableLanguageTags.map((languageTag) => [languageTag, message({}, { languageTag })]);
    return Object.fromEntries(entries);
}
